import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- entities
import {
  RestaurantMenu,
  ProductCategory
} from 'PMT/entities/menu';

// -- view
import UnusedCategoryRow from './UnusedCategoryRow';

class UnusedCategoriesListView extends Component {

  static propTypes = {
    restaurantMenu: PropTypes.instanceOf(RestaurantMenu),
  };

  //
  //
  //

  renderBody() {
    const unusedCategoriesIds = this.props.restaurantMenu.getUnusedCategoriesIds();

    if (_.isEmpty(unusedCategoriesIds)) {
      return this.renderNoUnused();
    }

    const rows = unusedCategoriesIds.map((id) => {
      const category = this.props.restaurantMenu.getCategoryWithId(id);
      return this.renderCategory(category);
    });

    return (
      <div className="table_container table_container_hover top-buffer-50">
        <table className="table">
          {this.renderTheadContent()}
          <tbody className="body">
            {rows}
          </tbody>
        </table>
      </div>
    );
  }

  renderCategory(category: ProductCategory) {
    return (
      <UnusedCategoryRow
        key={category.id}
        category={category}
        restaurantMenu={this.props.restaurantMenu}
      />
    );
  }

  renderNoUnused() {
    return (
      <div className="text-center">
        <p>
          {I18n.tr('menu.unused_category.no_unused_message')}
        </p>
      </div>
    )
  }

  renderTheadContent() {
    return (
      <thead>
        <tr>
          <th className="hidden-xs col-sm-2 text-left" />

          <th className="col-xs-8">
            {I18n.tr('menu.unused_category.table.header.name')}
          </th>
        </tr>
      </thead>
    );
  }

  render() {
    try {
    return (
      <div className="unused_categories_list_view top-buffer-50">
        <h3>{I18n.tr('menu.unused_category.title')}</h3>

        {this.renderBody()}
      </div>
    );
  } catch (e) { console.error(e) }
  }

}

export default UnusedCategoriesListView;
